// reducer.js
import {
  GET_ONLINE_COURSE_REQUEST,
  GET_ONLINE_COURSE_SUCCESS,
  GET_ONLINE_COURSE_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: [],
};

const getOnlineCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ONLINE_COURSE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_ONLINE_COURSE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        // total: action.payload.total,
      };
    case GET_ONLINE_COURSE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default getOnlineCourseReducer;
